import { useEffect, useState } from 'react';
import { cancelCheck, getTravelsCanceled } from '../services';
import { Socket, io } from 'socket.io-client';
import environment from 'environment/environment';
import { useSnackbar } from 'notistack';

enum Events {
  TRANSFER_RESERVATION_CANCELED = 'transfer_reservation_canceled',
  TRANSFER_RESREVATION_CANCELED_CHECKED = 'transfer_reservation_canceled_checked',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect'
}

export const useTravelsCanceled = () => {
  const [travels, setTravels] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const snackbar = useSnackbar();
  const [highlightedId, setHighlightedId] = useState<number | null>(null);
  const [countTravels, setCountTravels] = useState<number>(0);

  const getAllTravelsCanceled = async () => {
    try {
      setIsLoading(true);
      const response = await getTravelsCanceled();
      setTravels(response.data);
      setCountTravels(response.data.length);
    } finally {
      setIsLoading(false);
    }
  };

  const markTravelCancelCheck = async (id: number) => {
    const response = await cancelCheck(id);
    return response ? true : false;
  };

  useEffect(() => {
    const socket: Socket = io(environment.notifications, {
      autoConnect: true,
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      timeout: 10000 // Esperar 10 segundos antes de marcar timeout
    });

    // Funciones para manejar eventos
    const onNewTravelCancel = (data: any) => {
      setTravels((prev) => {
        const yaExiste = prev.some((v) => v.id === data.id);
        if (yaExiste) return prev;
        return [data, ...prev]; // o [...prev, nuevoViaje] según el orden que prefieras
      });

      setCountTravels((prev) => prev + 1);

      setHighlightedId(data.id);

      // Borrar el highlight luego de 5 segundos
      setTimeout(() => {
        setHighlightedId(null);
      }, 5000);
    };

    const onTravelCancelChecked = (data: any) => {
      setTravels((prev) => prev.filter((travel) => travel.id !== data.id));
      setCountTravels((prev) => prev - 1);
    };

    // Suscribirse a eventos
    socket.on(Events.TRANSFER_RESERVATION_CANCELED, onNewTravelCancel);
    socket.on(
      Events.TRANSFER_RESREVATION_CANCELED_CHECKED,
      onTravelCancelChecked
    );

    socket.on(Events.CONNECT, () => console.log('✅ Conectado a WebSocket'));
    socket.on(Events.DISCONNECT, () =>
      console.log('🔴 Desconectado de WebSocket')
    );

    // Cleanup cuando el componente se desmonta
    return () => {
      socket.off(Events.TRANSFER_RESERVATION_CANCELED, onNewTravelCancel);
      socket.off(
        Events.TRANSFER_RESREVATION_CANCELED_CHECKED,
        onTravelCancelChecked
      );
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Solo ejecutarlo una vez

  return {
    travels,
    isLoading,
    highlightedId,
    countTravels,
    markTravelCancelCheck,
    getAllTravelsCanceled
  };
};
